import { ColDef } from 'ag-grid-community';
import { SYSTEM_COLUMN_DEF } from 'FeatureModules/DataImport/utils/dataImport.constants';
import { TSystemColumns } from '../excelTable.types';
import DeleteCellRenderer from '../CellRenderers/SystemColumns/DeleteCellRenderer';

const DELETE_COLUMN: ColDef<TSystemColumns> = {
  ...SYSTEM_COLUMN_DEF,
  field: 'delete',
  pinned: 'right',
  cellRenderer: DeleteCellRenderer,
};

export default DELETE_COLUMN;
